import { Profiler } from "react";
import { Navigate, useParams } from "react-router-dom";

import DispatchView from "@/components/Dispatch/DispatchView";
import { channelPath } from "@/hooks/dispatch/channelPath";
import { useDispatchGate } from "@/hooks/dispatch/useDispatchEnabled";
import { profilerOnRender } from "@/services/perf/profilerOnRender";

/**
 * `/workspaces/:workspaceId/dispatch` and its popover route.
 *
 * Gated by the workspace's `web.dispatch.enabled`; see {@link useDispatchGate}. Renders nothing while the config is
 * loading, so a reload does not bounce off a gate that has not read yet. A workspace with Dispatch off goes to the
 * driver view, so a dispatcher on this page when the setting turns off follows it rather than stranding on a dead end:
 * an open driver's popover moves to that driver's channel, and the page itself to the workspace landing. Profiled as
 * `Dispatch`, so its commits reach the render metrics and the flight recorder.
 */
export default function Dispatch() {
  const { workspaceId, workspaceMembershipId, feedId } = useParams();
  const gate = useDispatchGate(workspaceId);

  if (gate === "loading") {
    return null;
  }

  if (gate === "disabled") {
    const driverChannel =
      workspaceId && workspaceMembershipId && feedId
        ? channelPath({ workspaceId, feedId, aliasMembershipId: workspaceMembershipId, dispatchEnabled: false })
        : `/workspaces/${workspaceId}`;
    return <Navigate to={driverChannel} replace />;
  }

  return (
    <Profiler id="Dispatch" onRender={profilerOnRender}>
      <DispatchView />
    </Profiler>
  );
}
